interface Props {
  showDifference: boolean;
  onToggleDifference: () => void;
  hasComparison: boolean;
}

export function CompareSection({ showDifference, onToggleDifference, hasComparison }: Props) {
  return (
    <div className="panel-section">
      <h2>Compare</h2>
      <button className={showDifference ? "active" : ""} onClick={onToggleDifference} disabled={!hasComparison}>
        {showDifference ? "Show overlay" : "Show difference"}
      </button>
      <p className="muted" style={{ fontSize: 11, marginTop: 6 }}>
        {hasComparison
          ? "Right-click an epoch to set/clear the comparison."
          : "Right-click an epoch on the left to enable A/B comparison."}
      </p>
    </div>
  );
}
